module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sales/sales-list/sales-list.component.css
// module id = ./src/app/sales/sales-list/sales-list.component.css
// module chunks = main